// extracted by mini-css-extract-plugin
module.exports = {"bpWrapper":"BonusPointsBanner_bpWrapper__CSzJB"};